import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Notification } from "../../../components/GenericActions";
import phoneVerificationService from "./phoneVerification.service";

const initialState = {
  isOtp: null,
  isresendOtp: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  statusMessage: "",
};

export const verifyNumberOtp = createAsyncThunk(
  "verify/numberOtp",
  async ({ finalData, moveToOTPCode }, thunkAPI) => {
    try {
      const response = await phoneVerificationService.confirmNumberOtp(
        finalData
      );
      if (response.succeeded === true) {
        if (moveToOTPCode) {
          moveToOTPCode(response);
        }
      }
      Notification(response.message, response.succeeded);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const resendNumberOtp = createAsyncThunk(
  "verify/resendOtp",
  async ({ resendOtpData, moveToNext }, thunkAPI) => {
    try {
      const response = await phoneVerificationService.resendNumberOtp(
        resendOtpData
      );
      if (response.succeeded === true) {
        if (moveToNext) {
          moveToNext();
        }
      }
      Notification(response.message, response.succeeded);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const phoneVerificationSlice = createSlice({
  name: "verifyNumber",
  initialState,
  reducers: {
    clearData: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.statusMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyNumberOtp.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(verifyNumberOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isOtp = action.payload;
      })
      .addCase(verifyNumberOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      })

      .addCase(resendNumberOtp.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(resendNumberOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isresendOtp = action.payload;
      })
      .addCase(resendNumberOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      });
  },
});
export const { clearData } = phoneVerificationSlice.actions;

export default phoneVerificationSlice.reducer;
